import { memo, useMemo } from "react";

import type { IIconProps } from "@components/atoms/icon/types";
import { IconCore } from "@components/icon";
import { fontSizeToRem } from "@/utils/fontSizeMapper";
import { getThemeColor } from "@/theme";

export const Icon = memo(function Icon({
  name,
  fontSize,
  customSize,
  color,
  className,
}: IIconProps) {
  const size = useMemo(
    () => (fontSize ? `${fontSizeToRem(fontSize)}rem` : customSize),
    [customSize, fontSize],
  );

  return (
    <IconCore
      className={className}
      iconName={name}
      color={
        color ? getThemeColor(color || "text-sub-600").colorValue : undefined
      }
      size={size}
    />
  );
});
